import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetootstationcabs() {



  const cardData =
  {
    keyword: 'Pune to outstation cabs  ',
    heading: 'Sai Trupti Cabs: Pune to outstation cabs',
    headingDescription: 'Sai Trupti Cabs offers reliable and comfortable Pune to outstation cab services, designed to make your long-distance journeys smooth and stress-free. Our fleet includes well-maintained, air-conditioned Sedans, SUVs, and Premium vehicles — all equipped with clean interiors and ample luggage space. Every trip is driven by a professional, background-verified chauffeur who ensures punctual pickup in Pune, courteous service, and safe, smooth driving to your outstation destination. With transparent fares, flexible booking options (one-way or round-trip), and 24×7 customer support, Sai Trupti Cabs makes your travel from Pune to any outstation convenient, affordable, and worry-free.',

    top: 'Top Places to Visit in Pune with Sai Trupti Cabs',

"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada is the crown jewel of Pune’s Maratha heritage, built in 1732 by the Peshwas as the seat of their empire. Once a magnificent seven-storey palace, its grand gates, carved teak balconies, and sprawling courtyards reflect royal elegance and political power. Though much of it was destroyed by fire, the fort’s ruins still whisper tales of valor, intrigue, and sacrifice. The evening light-and-sound show revives the Peshwa era through mesmerizing narration and music. Shaniwar Wada remains the emotional heart of Pune — where history, culture, and pride unite."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace stands as an enduring symbol of India’s freedom movement and Mahatma Gandhi’s legacy. Built in 1892 by Sultan Aga Khan III, the palace later became a place of internment for Gandhi, Kasturba Gandhi, and other leaders during the Quit India Movement. The tranquil gardens, memorials, and museum preserve their memories and personal belongings. Its elegant Italian arches and serene ambiance make it both a historical monument and a place of reflection. Every corner tells a story of sacrifice, resilience, and the unbreakable spirit of India’s struggle for independence."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Perched atop the rugged Sahyadri ranges, Sinhagad Fort is a timeless symbol of Maratha courage and pride. The fort gained fame after the legendary battle led by Tanaji Malusare under the command of Chhatrapati Shivaji Maharaj. Trekking up its steep slopes rewards visitors with panoramic views of the valley and Pune city. The fort’s stone walls, ancient gates, and rustic stalls serving pithla-bhakri bring history to life. Sinhagad is not just a fortress — it’s an experience of heritage, adventure, and the indomitable spirit of the Marathas."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple is a fascinating 8th-century rock-cut shrine carved from basalt, dedicated to Lord Shiva. Located in the heart of Pune, it offers a peaceful escape from city noise and chaos. The circular Nandi mandapa, massive stone pillars, and unfinished sanctum reflect remarkable ancient craftsmanship. Believed to have been excavated during the Rashtrakuta dynasty, the temple’s spiritual aura attracts devotees and historians alike. Amid modern Pune’s growth, Pataleshwar stands as a reminder of its deep and timeless spiritual roots."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill rises gracefully over Pune, offering both divine blessings and breathtaking views. The temple complex atop the hill is dedicated to Lord Shiva and Goddess Parvati and was built by the Peshwas in the 18th century. Climbing its 108 stone steps is both a spiritual and meditative experience, rewarded by panoramic views of the city below. The site also houses the Peshwa Museum, which preserves rare artifacts of Maratha glory. At sunrise and sunset, Parvati Hill becomes a golden haven of peace, history, and devotion."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "The Dagdusheth Halwai Ganpati Temple is Pune’s most beloved spiritual landmark, drawing millions of devotees each year. The temple’s magnificent idol of Lord Ganesha, adorned with gold ornaments and fresh flowers, radiates devotion and positivity. During Ganesh Chaturthi, the entire area transforms into a festival of lights, music, and prayer. The temple also supports charitable causes, embodying the true essence of faith in action. Whether you visit for blessings or simply to soak in its energy, Dagdusheth Temple fills every heart with peace and joy."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum is a treasure house of Indian art and tradition, housing over 20,000 artifacts collected by the late Dr. Dinkar Kelkar. Its exhibits include intricate musical instruments, ancient sculptures, traditional ornaments, and everyday objects that reveal India’s creative spirit. The museum’s highlight is the replica of a 17th-century Wada — a traditional Maharashtrian mansion. Walking through its corridors feels like stepping back in time. It’s a must-visit for art lovers, history enthusiasts, and anyone seeking to rediscover India’s cultural richness."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, just 20 km from Pune, is a popular getaway surrounded by rolling hills and lush greenery. Built across the Mutha River, it serves as the city’s primary water source and a serene picnic spot for families and friends. Visitors enjoy the mesmerizing sunset reflecting off the calm waters while savoring local snacks from nearby stalls. During monsoon, the dam’s scenic charm doubles, making it a photographer’s paradise. It’s the perfect escape for those seeking peace, nature, and a cool breeze away from urban life."
  },
  {
    "title": "Osho International Meditation Resort",
    "description": "Located in Koregaon Park, Osho International Meditation Resort is a tranquil oasis that attracts visitors from across the globe. Spread over lush gardens and modern Zen-inspired architecture, it offers various meditation sessions, wellness therapies, and workshops on mindfulness. The serene environment encourages introspection and personal growth. Beyond being a retreat, Osho Resort reflects Pune’s cosmopolitan identity — blending spirituality, modernity, and holistic living. It’s where silence meets luxury, creating an experience that rejuvenates both body and soul."
  },
  {
    "title": "Pune Okayama Friendship Garden (Pu La Deshpande Udyan)",
    "description": "Inspired by Japan’s famous Korakuen Garden, the Pune Okayama Friendship Garden — also known as Pu La Deshpande Udyan — is an exquisite symbol of Indo-Japanese friendship. Spread across 10 acres, its winding paths, small bridges, ponds, and manicured lawns create a serene landscape ideal for relaxation and photography. The garden’s harmony between Japanese design and Indian flora makes it one of Pune’s most aesthetic green spaces. Families, nature lovers, and photographers visit to unwind amid its calming beauty and artistic symmetry."
  }
],



  "services": [
    {
      "name": "Outstation Car Rental Pune",
      "description": "Premium outstation car rental service in Pune offering AC and non-AC vehicles for long-distance travel. Features professional chauffeurs, flexible pickup/drop points, luggage assistance, real-time tracking, and transparent fares. Ideal for family trips, business travel, temple tours, and weekend getaways across Maharashtra and nearby states."
    },
    {
      "name": "Pune to Outstation Cab",
      "description": "Reliable cab service from Pune to various outstation destinations including Shirdi, Nashik, Goa, Bangalore, Hyderabad, Lonavala, and Kolhapur. Offers Sedans, SUVs, Innova, and luxury vehicles with AC/non-AC options, professional drivers, luggage support, and point-to-point travel for hassle-free journeys."
    },
    {
      "name": "Outstation Taxi Service Pune",
      "description": "Trusted outstation taxi service in Pune providing door-to-door pickup and drop. Features experienced drivers, comfortable vehicles, flexible schedules, real-time tracking, and safe travel for long-distance journeys. Perfect for corporate travel, family trips, and weekend excursions."
    },
    {
      "name": "One Way Cab Pune",
      "description": "Convenient one-way cab service from Pune for travelers seeking direct point-to-point travel. Offers multiple vehicle options including AC/Non-AC Sedans, SUVs, Innova, and Tempo Travellers with professional drivers and transparent pricing. Ideal for short and long-distance trips."
    },
    {
      "name": "Best Outstation Cab Service in Pune",
      "description": "Top-rated outstation cab service in Pune offering premium vehicles, punctual drivers, AC/non-AC options, luggage assistance, and real-time tracking. Perfect for business trips, family excursions, temple tours, and leisure travel across Maharashtra and neighboring states."
    },
    {
      "name": "Taxi in Pune for Outstation",
      "description": "Reliable taxi service in Pune for outstation travel. Includes Sedans, SUVs, Innova, and luxury vehicles with professional drivers, comfortable seating, flexible pickup/drop options, luggage support, and competitive fares for safe and hassle-free long-distance trips."
    },
    {
      "name": "Pune Airport to Kolhapur Cab",
      "description": "Direct cab service from Pune Airport to Kolhapur offering AC/non-AC vehicles, experienced chauffeurs, luggage assistance, and flexible pickup times. Ideal for business travelers, tourists, and long-distance travelers seeking comfort and reliability."
    },
    {
      "name": "Pune Car Rental Outstation",
      "description": "Outstation car rental service from Pune providing vehicles for corporate, family, and leisure travel. Includes Sedans, SUVs, Innova, Crysta, Tempo Travellers, and luxury cars with professional drivers, luggage support, and competitive fares."
    },
    {
      "name": "Pune to Gokarna Cab",
      "description": "Outstation cab service from Pune to Gokarna with comfortable AC/non-AC vehicles, experienced drivers, luggage support, and transparent pricing. Ideal for long-distance leisure travel and beach trips."
    },
    {
      "name": "Pune Outstation Innova Cab",
      "description": "Spacious Innova cab service for Pune outstation travel offering superior comfort, AC travel, ample luggage space, and professional drivers. Perfect for family trips, group travel, and corporate journeys."
    },
    {
      "name": "Pune Outstation Innova Crysta Cab",
      "description": "Premium Innova Crysta cab for Pune outstation trips featuring luxury interiors, AC comfort, smooth ride on highways, professional drivers, luggage assistance, and transparent fares for a hassle-free travel experience."
    },
    {
      "name": "Pune Outstation Ertiga Cab",
      "description": "Economical Ertiga cab for Pune outstation travel suitable for small groups and families. Offers AC/non-AC options, professional drivers, luggage support, and comfortable highway travel."
    },
    {
      "name": "Pune Outstation Sedan Cab",
      "description": "Sedan cab service for Pune outstation trips providing smooth and comfortable travel for solo travelers, couples, and small families. Includes AC/non-AC vehicles, experienced drivers, and luggage assistance."
    },
    {
      "name": "Pune Outstation SUV Taxi",
      "description": "SUV taxi service from Pune for outstation travel offering enhanced safety, better ground clearance, AC comfort, and professional drivers. Ideal for family trips, corporate travel, and long highway journeys."
    },
    {
      "name": "Pune Outstation Tempo Traveller",
      "description": "Tempo Traveller service for Pune outstation travel ideal for group trips, corporate tours, and pilgrimages. Offers spacious seating, AC options, luggage support, and professional drivers for a safe and comfortable journey."
    },
    {
      "name": "Pune to Mumbai Outstation Cab",
      "description": "Outstation cab service from Pune to Mumbai with multiple vehicle options including AC Sedans, SUVs, and Innova. Features experienced drivers, flexible pickup points, luggage assistance, and transparent fare for seamless long-distance travel."
    },
    {
      "name": "Pune to Nashik Outstation Cab",
      "description": "Reliable outstation cab service from Pune to Nashik providing comfortable AC/non-AC vehicles, professional chauffeurs, luggage support, and point-to-point service ideal for business, leisure, and pilgrimage trips."
    },
    {
      "name": "Pune to Shirdi Outstation Cab",
      "description": "Direct outstation cab service from Pune to Shirdi offering AC/non-AC vehicles, experienced drivers, luggage support, and one-way or round-trip options. Perfect for pilgrims visiting the Sai Baba temple."
    },
    {
      "name": "Pune to Lonavala Outstation Cab",
      "description": "Comfortable cab service from Pune to Lonavala for weekend trips, hill station visits, and family outings. Features AC/non-AC cars, professional drivers, scenic route experience, and flexible scheduling."
    },
    {
      "name": "Pune to Goa Outstation Cab",
      "description": "Long-distance outstation cab service from Pune to Goa providing AC/non-AC vehicles, professional drivers, luggage assistance, and comfortable highway travel. Ideal for leisure trips, family vacations, and group travel."
    },
    {
      "name": "Pune to Kolhapur Outstation Cab",
      "description": "Cab service from Pune to Kolhapur for outstation travel offering AC/non-AC vehicles, professional drivers, luggage assistance, and point-to-point service for business and tourism purposes."
    },
    {
      "name": "Pune to Bangalore Outstation Cab",
      "description": "Outstation cab service from Pune to Bangalore providing AC/non-AC vehicles, professional drivers, luggage support, and long-distance highway travel. Perfect for corporate travel, family trips, and one-way or round trips."
    },
    {
      "name": "Pune to Hyderabad Outstation Cab",
      "description": "Long-distance cab service from Pune to Hyderabad offering comfortable AC/non-AC vehicles, professional chauffeurs, luggage support, and flexible schedules for business and leisure travelers."
    },
    {
      "name": "Pune Outstation Cab for Family Trip",
      "description": "Family-friendly outstation cab service from Pune with spacious vehicles, AC comfort, luggage assistance, and experienced drivers. Ideal for long-distance trips, weekend getaways, and group travel."
    },
    {
      "name": "Pune Outstation Cab for Corporate Travel",
      "description": "Corporate-focused outstation cab service from Pune providing AC Sedans, SUVs, and Innova vehicles, professional drivers, real-time tracking, punctual service, and flexible scheduling for business trips."
    },
    {
      "name": "Pune Outstation Cab for Temple Darshan",
      "description": "Religious outstation cab service from Pune for temple darshan trips. Offers AC/non-AC vehicles, experienced drivers familiar with pilgrimage routes, luggage support, flexible timings, and transparent fares."
    },
    {
      "name": "Pune Outstation Cab for Weekend Trip",
      "description": "Weekend getaway cab service from Pune offering comfortable AC/non-AC vehicles, professional drivers, luggage assistance, and scenic routes to destinations like Lonavala, Panchgani, Mahabaleshwar, and Gokarna."
    },
    {
      "name": "Pune Outstation Cab for Senior Citizens",
      "description": "Senior citizen-friendly outstation cab service from Pune providing comfortable vehicles, patient drivers, flexible schedules, luggage assistance, and safe, scenic travel for long-distance trips."
    }
  ],
  "tableData": [
    ["Outstation Car Rental Pune", "Pune to Outstation Cab"],
    ["Outstation Taxi Service Pune", "One Way Cab Pune"],
    ["Best Outstation Cab Service in Pune", "Taxi in Pune for Outstation"],
    ["Taxi Service in Pune for Outstation", "Outstation Taxi in Pune"],
    ["Outstation Car Rental Services Pune Maharashtra", "Outstation Taxi Service in Pune"],
    ["Pune Airport to Kolhapur Cab", "Pune Car Rental Outstation"],
    ["Pune to Gokarna Cab", "Pune to Outstation Taxi"],
    ["Pune to Outstation Cabs", "Outstation Cab Service in Pune"],
    ["Pune Outstation Cab Service", "Pune to Outstation Taxi"],
    ["Outstation Taxi from Pune", "Outstation Cab Booking Pune"],
    ["Pune Outstation Innova Cab", "Pune Outstation Innova Crysta Cab"],
    ["Pune Outstation Ertiga Cab", "Pune Outstation Sedan Cab"],
    ["Pune Outstation SUV Taxi", "Pune Outstation Tempo Traveller"],
    ["Pune to Mumbai Outstation Cab", "Pune to Nashik Outstation Cab"],
    ["Pune to Shirdi Outstation Cab", "Pune to Lonavala Outstation Cab"],
    ["Pune to Goa Outstation Cab", "Pune to Kolhapur Outstation Cab"],
    ["Pune to Bangalore Outstation Cab", "Pune to Hyderabad Outstation Cab"],
    ["Pune Outstation Cab for Family Trip", "Pune Outstation Cab for Corporate Travel"],
    ["Pune Outstation Cab for Temple Darshan", "Pune Outstation Cab for Weekend Trip"],
    ["Pune Outstation Cab for Senior Citizens", ""]
  ],




"whychoose": [
  {
    "WhyChooseheading": "Pune to Outstation Cab Service",
    "WhyChoosedescription": "Sai Trupti Cabs offers reliable and comfortable outstation cab services from Pune — ideal for weekend trips, business travel, family outings, and leisure journeys."
  },
  {
    "WhyChooseheading": "Transparent & Competitive Fare",
    "WhyChoosedescription": "Our outstation fares from Pune start from approximately ₹2,500–₹4,000 for sedans, with SUVs and premium vehicles available at affordable rates depending on distance and vehicle type."
  },
  {
    "WhyChooseheading": "Wide Range of Vehicle Options",
    "WhyChoosedescription": "Choose from hatchbacks, sedans, SUVs, tempo travellers, or premium cars to suit your group size, luggage requirements, and comfort preferences for your Pune outstation trip."
  },
  {
    "WhyChooseheading": "Professional & Experienced Drivers",
    "WhyChoosedescription": "Our courteous and skilled drivers are experienced in long-distance travel from Pune to various cities, ensuring a safe, smooth, and timely journey."
  },
  {
    "WhyChooseheading": "Flexible Pickup & Drop Locations",
    "WhyChoosedescription": "We offer convenient pickups anywhere in Pune and drop-offs at your destination city, hotel, residence, or tourist spot."
  },
  {
    "WhyChooseheading": "Clean & Well-Maintained Vehicles",
    "WhyChoosedescription": "All vehicles are regularly serviced, sanitized, and equipped with essential amenities for a comfortable and hygienic long-distance ride."
  },
  {
    "WhyChooseheading": "24/7 Booking & Customer Support",
    "WhyChoosedescription": "Our support team is available round the clock to help with bookings, route planning, or travel assistance for your Pune outstation cab trip."
  },
  {
    "WhyChooseheading": "Hassle-Free Booking Process",
    "WhyChoosedescription": "Book your Pune outstation cab easily through a call, WhatsApp, or our website — with instant confirmation and quick vehicle dispatch."
  }
]



  }

const faqData = [
  {
    question: 'Does Sai Trupti Cabs offer Pune to outstation cab services?',
    answer: 'Yes, Sai Trupti Cabs provides reliable and affordable cab services from Pune to various outstation destinations for one-way, round-trip, and group travel.',
  },
  {
    question: 'How can I book a Pune to outstation cab with Sai Trupti Cabs?',
    answer: 'You can book your Pune to outstation cab through our website, mobile app, WhatsApp, or by contacting our 24×7 customer support team.',
  },
  {
    question: 'What types of cabs are available for Pune outstation trips?',
    answer: 'We offer hatchbacks, sedans, SUVs, Ertiga, Innova Crysta, tempo travellers, and luxury cabs for Pune outstation travel.',
  },
  {
    question: 'Are the drivers experienced for Pune outstation trips?',
    answer: 'Yes, all our drivers are professional, courteous, and experienced in long-distance travel from Pune to various cities.',
  },
  {
    question: 'Can I hire a cab from Pune for a multi-day outstation trip?',
    answer: 'Yes, we offer flexible outstation cab services for multi-day trips, weekend getaways, or corporate travel.',
  },
  {
    question: 'Is the Pune outstation cab service available 24×7?',
    answer: 'Yes, Sai Trupti Cabs offers 24×7 cab services for Pune outstation trips.',
  },
  {
    question: 'What are the Pune outstation cab fares?',
    answer: 'Our fares start from approximately ₹2,500 for sedans and ₹4,000–₹6,500 for SUVs and premium vehicles, depending on distance and travel requirements.',
  },
  {
    question: 'What payment options are accepted for Pune outstation cab bookings?',
    answer: 'We accept payments via UPI, credit/debit cards, bank transfers, and digital wallets.',
  },
  {
    question: 'What safety and hygiene protocols are followed for Pune outstation cabs?',
    answer: 'All vehicles are sanitized before every trip, and drivers follow strict hygiene and safety measures.',
  },
  {
    question: 'Is customer support available during the Pune outstation cab ride?',
    answer: 'Yes, our 24×7 customer support team is available throughout your Pune outstation cab journey.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Sandeep Jadhav',
    feedback: 'We booked an outstation cab from Pune to Lonavala. Very comfortable ride and on-time service.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Priya Deshmukh',
    feedback: 'Excellent Pune outstation cab service. Polite driver, clean car, and hassle-free booking.',
    rating: 5,
  },
];

















































































  const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
  { place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
  { place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
  { place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cab", link: "Pune-to-Mumbai-One-Way-Cab" },
  { place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
  { place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
  { place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
  { place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cab", link: "Hinjewadi-to-Mumbai-Cab" },
  { place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cab", link: "Wakad-to-Mumbai-Cab" },
  { place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cab", link: "Hadapsar-to-Mumbai-Cab" },
  { place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
  { place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cab", link: "Koregaon-Park-to-Mumbai-Cab" },
  { place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cab", link: "Kothrud-to-Mumbai-Cab" },
  { place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cab", link: "Kharadi-to-Mumbai-Cab" },
  { place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cab", link: "Shivajinagar-to-Mumbai-Cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cab", link: "Pune-to-Mumbai-Innova-Crysta-Cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
  { place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cab", link: "Kondhwa-to-Mumbai-Cab" },
  { place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
  { place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];















const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Outstation Cabs",
  "image": "https://saitrupticabs.com/assets/images/pune-to-shirdi-cab.jpg",
  "description": "Book Pune to Outstation Cab Service with Sai Trupti Cabs for a safe, comfortable, and affordable ride. Choose AC sedans, SUVs, or Innova for one-way, round-trip, and multi-day outstation travel with verified drivers and 24/7 online booking.",
  "brand": {
    "@type": "Brand",
    "name": "Sai Trupti Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "15864"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2399",
    "availability": "https://schema.org/InStock",
    "url": "https://saitrupticabs.com/pune-to-outstation-cabs"
  }
};






  return (
    <div>
      <Helmet>
  <title>Pune to Outstation Cab Service | Safe & Comfortable | Sai Trupti Cabs</title>
  <meta 
    name="description" 
    content="Book Pune to Outstation Cab Service with Sai Trupti Cabs for a safe, comfortable, and affordable ride. Choose AC sedans, SUVs, or Innova for one-way, round-trip, and multi-day outstation travel with verified drivers and 24/7 online booking." 
  />
  <meta 
    name="keywords" 
    content="Pune to Outstation Cabs, Pune Outstation Taxi, Pune to Outstation Cab Service, Pune to Outstation Car Hire, Pune Outstation Innova Cab, Pune Outstation Ertiga Cab, Pune Outstation Sedan Cab, Pune Outstation One Way Cab, Pune Outstation Round Trip Cab, Pune Outstation Luxury Cab, Affordable Pune Outstation Cab, Pune Outstation AC Cab, Pune Outstation Online Booking, Pune Outstation Corporate Cab, Pune Outstation Cab Near Me" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


<section
      className="breadcrumb-section"
      style={{ backgroundImage: "url(/images/background/inner-banner-bg.png)" }}
    >
      <div className="container">
        <div className="banner-content">
          <h1> {cardData.keyword}</h1>
        </div>
      </div>
    </section>



      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/92.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sai Trupti Cabs</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sai Trupti Cabs </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918390907004" className="pc-call">+91 8390907004</a>
                      <a href="tel:+919922727744" className="pc-call">+91 9922727744</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918390907004"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918390907004" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@saitrupticabs.com" className="pc-email">
                      booking@saitrupticabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sai Trupti Cabs </strong><br />
                      Yashoda splendid Park,
                      Office number D. Wing Dudulgaon Anandi,
                        ruial Sainath Chowk Alandi-412105
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetootstationcabs;